import { useLayoutEffect, useRef } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

// A CSS animation starts counting when its element mounts, so spinners that appear at
// different moments (one chapter starts generating after another) rotate out of phase.
// Re-anchoring them to the document timeline origin keeps every spinner on screen at the
// same angle, no matter when it appeared.
export function SyncedSpinner({ className }: { className?: string }) {
  const ref = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    for (const animation of ref.current?.getAnimations() ?? []) {
      animation.startTime = 0;
    }
  }, []);

  return <span ref={ref} aria-hidden className={cn("block animate-spin", className)} />;
}
